import { defineComponent as _defineComponent } from 'vue'
import { useSlots, computed, onMounted, watch, ref, type Ref } from 'vue'
import { useLoadingState } from '@/packages/vue-loading-state'
import { catalogApi } from '@/services/catalog.service'
// import { useSnapCarousel } from '@/composables/useSnapSlider'
import ProductMainPreview from '../general/ProductMainPreview.vue'

import { Swipe } from '@/utils/swipe'

const ZERO = 0


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicOffers',
  props: {
    tokenString: {},
    limit: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const innerContentScroller = (direction, distance, box) => {
  if ('left' === direction) {
    box.scrollLeft += distance
  } else if ('right' === direction) {
    box.scrollLeft -= distance
  }
}

const props = __props

const keyForInit = ref(Date.now())
const sliderRef = ref(null)
const prevBtnRef = ref(null)
const nextBtnRef = ref(null)
const distance = computed(() => {
  if (sliderRef.value?.firstChild) {
    return (sliderRef.value?.firstChild as HTMLDivElement).nextSibling
      .clientWidth
  }
  return 0
})

const isAvailable = computed(() => Boolean(sliderRef.value?.scrollWidth - sliderRef.value?.clientWidth > 2))


// const {
//   init,
//   checkAvailability,
//   snapSlider,
//   isAvailable,
//   isHasPrev,
//   isHasNext,
//   nextSlide,
//   prevSlide,
// } = useSnapCarousel(sliderRef)

const slots = useSlots()
const { load, loading } = useLoadingState()

const offers = ref([])

function getOffers() {
  load(
    catalogApi.offers.list
      .execute({
        token_string: props.tokenString,
        limit: props.limit,
      })
      .then(({ items }) => {
        offers.value = items
        if (items.length) {
          // setTimeout(() => {
          //   initCarousel()
          // }, 100)
          setTimeout(() => {
            sliderControl(sliderRef.value)
            keyForInit.value = Date.now()
          }, 1000)
        }
      })
  )
}
getOffers()

// function initCarousel() {
//   // require next event loop for await render
//   init({ current: 1 })
//   checkAvailability(sliderRef.value)
//   // nextTick(() => {
//   //   setTimeout(() => {
//   //     snapSlider.value.update()
//   //     sliderRef.value.scrollTo({ left: 0 })
//   //   }, 100)
//   // })
// }
const isHasPrev = ref(false)
const isHasNext = ref(true)

function sliderControl(box: HTMLDialogElement) {
  if (navigator.maxTouchPoints > ZERO || navigator?.msMaxTouchPoints > ZERO)
    return
  // SWIPE INITIALIZATION
  const swipe = new Swipe(box, {
    corners: true,
    minDistance: 200,
  })

  const liveEvent = swipe.addEventListener('live', (direction, distance) => {
    // runAnimation(direction);
    innerContentScroller(direction, distance.value, box)
  })
  // const [controls] = parent.getElementsByClassName('snap-controls')
}
// prev
function prevSlide() {
  const box = sliderRef.value
  isHasPrev.value = true
  isHasNext.value = true
  innerContentScroller('right', distance.value, box)
  setTimeout(() => {
    isHasPrev.value = box.scrollLeft > 2

    isHasNext.value = box.scrollLeft + box.clientWidth <= box.scrollWidth - 65
  }, 500)
}
// next
function nextSlide() {
  const box = sliderRef.value
  isHasPrev.value = true
  isHasNext.value = true
  innerContentScroller('left', distance.value, box)
  setTimeout(() => {
    isHasPrev.value = box.scrollLeft > 2
    isHasNext.value = box.scrollLeft + box.clientWidth <= box.scrollWidth - 65
  }, 500)
}


const __returned__ = { innerContentScroller, ZERO, props, keyForInit, sliderRef, prevBtnRef, nextBtnRef, distance, isAvailable, slots, load, loading, offers, getOffers, isHasPrev, isHasNext, sliderControl, prevSlide, nextSlide, useSlots, computed, onMounted, watch, ref, get useLoadingState() { return useLoadingState }, get catalogApi() { return catalogApi }, ProductMainPreview, get Swipe() { return Swipe } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})